// App.vue
<template>
  <div
    id="app"
    class="w-full h-full relative"
  >
    <RouterView />
  </div>
</template>

<script setup lang="ts">import { useCanvasStore } from '@/stores/qs-store-canvas'
import { usePanelStore } from '@/stores/qs-store-panels'
import { useEventListener, useWindowSize } from '@vueuse/core'
import { onMounted, onUnmounted, watch } from 'vue'

const canvasStore = useCanvasStore()
const panelStore = usePanelStore()

const runPanelResetFromHash = () => {
  const hash = window.location.hash.toLowerCase()
  if (hash === '#panelreset' || hash === '#/panelreset') {
    panelStore.resetPanelPositions()
    canvasStore.centerArtboard()
    if (hash === '#/panelreset') {
      window.history.replaceState(null, '', window.location.pathname + window.location.search + '#/')
    }
  }
}

onMounted(() => {
  runPanelResetFromHash()
})

useEventListener(window, 'hashchange', runPanelResetFromHash)

const { width, height } = useWindowSize()

const stopWatcher = watch([width, height], () => {
  canvasStore.updateDimensions()
})

onUnmounted(() => {
  stopWatcher()
})</script>

<style scoped>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}
</style>